module.exports = __webpack_public_path__ + "static/media/bottlings7.a5f09ba4.jpg";